<template>
  <div class="demo">
    <div class="banner" :class="name">
      <div class="w1200">
        <h3>成功案例</h3>
        <h4>{{ initData.title }}</h4>
        <p>{{ initData.description }}</p>
        <div class="button-bg">
        <div
          class="button"
          @click="
            showDialog = true
            systemId = '3'
          "
        >
          获取最新解决方案
          <i class="el-icon-arrow-right"></i>
        </div>
        </div>
      </div>
    </div>
    <div class="container w1200">
      <el-container style="height: 600px;">
        <el-aside width="280px">
          <div class="tag">客户介绍</div>
          <div class="logo" :class="name"></div>
          <div class="desc">
            <div class="title">{{ initData.area }}</div>
            <ul class="content">
              <li :key="index" v-for="(items, index) in initData.content">
                <em v-if="index == 0">公司简介：</em>
                {{ items }}
              </li>
            </ul>
          </div>
        </el-aside>
        <el-main>
          <template v-if="name == 'cdy'">
          <cdy></cdy>
        </template>
        <template v-if="name == 'wfh'">
          <wfh></wfh>
        </template>
          <template v-if="name == 'hy'">
            <hy></hy>
          </template>  
          <template v-if="name == 'dlw'">
            <dlw></dlw>
          </template>
          <template v-if="name == 'dsw'">
            <dsw></dsw>
          </template>
          <template v-if="name == 'gjw'">
            <gjw></gjw>
          </template>
          <template v-if="name == 'hlw'">
            <hlw></hlw>
          </template>
          <template v-if="name == 'hsw'">
            <hsw></hsw>
          </template>
          <template v-if="name == 'jlw'">
            <jlw></jlw>
          </template>
          <template v-if="name == 'kfw'">
            <kfw></kfw>
          </template>
          <template v-if="name == 'llw'">
            <llw></llw>
          </template>
          <template v-if="name == 'zjs'">
            <zjs></zjs>
          </template>
          <template v-if="name == 'zlw'">
            <zlw></zlw>
          </template>
          <template v-if="name == 'ylw'">
            <ylw></ylw>
          </template>
          <template v-if="name == 'xxtd'">
            <xxtd></xxtd>
          </template>
          <template v-if="name == 'yxzh'">
            <yxzh></yxzh>
          </template>
          <template v-if="name == 'gjjys'">
            <gjjys></gjjys>
          </template>
          <template v-if="name == 'xhj'">
            <xhj></xhj>
          </template>
        </el-main>
      </el-container>
    </div>
    <dialog-box
      :showDialog="showDialog"
      :systemId="systemId"
      @close="showDialog = false"
    ></dialog-box>
  </div>
</template>

<script>
import dialogBox from './components/dialog'
import dlw from './components/dlw'
import dsw from './components/dsw'
import gjw from './components/gjw'
import hlw from './components/hlw'
import hsw from './components/hsw'
import jlw from './components/jlw'
import kfw from './components/kfw'
import llw from './components/llw'
import zjs from './components/zjs'
import zlw from './components/zlw'
import ylw from './components/ylw'
import hy from './components/hy'
import cdy from './components/cdy'
import wfh from './components/wfh'
import xxtd from './components/xxtd'
import yxzh from './components/yxzh'
import xhj from './components/xhj'
import gjjys from './components/gjjys'
export default {
  components: {
    dialogBox,
    dlw,
    dsw,
    gjw,
    hlw,
    hsw,
    jlw,
    kfw,
    llw,
    zjs,
    zlw,
    ylw,
    hy,
    wfh,
    cdy,
    xxtd,
    yxzh,
    gjjys,
    xhj
  },
  data() {
    return {
      systemId: '3',
      showDialog: false,
      name: 'kfw',
      initData: {
        name: '',
      },
    }
  },

  created() {
    this.name = this.$route.params.name || 'kfw'
    this.loadData()
  },

  methods: {
    loadData() {
      switch (this.name) {
        case 'wfh':
          this.initData = {
            title: '文峰集团',
            description:
              '南通本地最大市民综合服务平台解决方案',
            area: '江苏文峰集团有限公司',
            content: [
              '江苏文峰集团有限公司是一家以商贸业、酒店业、汽车服务业、房地产和产业投资为发展主体的综合型企业集团。江苏文峰集团有限公司是一家以商贸业、酒店业、汽车服务业、 房地产开发和产业投资为发展主体的综合型企业集团。',
              '目前集团拥有全资或控股企业百余家，员工25000人，年营业收入近220亿元，总资产逾200亿元，已连续十多年名列中国民营企业500强，被江苏省委、省政府授予“优秀民营企业”，被南通市委、市政府授予“民营金牌企业”“纳税特别贡献企业”等荣誉称号。在二十多年的发展进程中，文峰集团始终以不断完善与超越自我为目标，注重汲取国际经验、吸收优秀人才与企业发展的互动作用，不断推进集团的发展。',
            ],
          }
          break
          case 'cdy':
          this.initData = {
            title: '草都云',
            description:
              '草畜一体化园区综合解决方案',
            area: '内蒙古草都草牧业股份有限公司',
            content: [
              '草都饲草（股票代码837687）打造绿色畜产品食品安全第一车间，把好乳肉食品安全第一关。以草产业发展为己任，以生态草业为抓手，实现产业生态化，让牛马羊吃得更健康，让农牧民过得更幸福，构建卓越的草牧业运营服务商，围绕草牧、草生态、草经济构建草牧业数智化供应链服务平台。',
              '目前在内蒙古自治区呼和浩特市、锡林浩特市、呼伦贝尔市、赤峰市、巴彦淖尔市，河北省衡水市、张家口市，黑龙江省肇东市等国内牧草核心区布局11个基地，可控天然草场超200万亩，人工草地80万亩，是国内有机牧草认证最多的企业之一。服务华北牲畜市场、光明乳业、新希望乳业、君乐宝等客户。',
              '在草牧业园区布局上，现已在张北、和林格尔、锡盟毛登牧场、赤峰阿旗等四个区域布局草牧业园区项目，在衡水市安平县和张家口尚义县分别布局生态及退耕还草项目。通过服务各地政府草牧业园区、退耕还草、生态与生产坚固的草地修复获取草地资源，赋能牧草种植合伙人和牛经纪人，专注草地、草、牛马羊的收储、分级，实现草和牛的统购统销，构建草牧业生态圈。',
              '草都云利用数字和科技的力量，把草牧业各环节各要素数在线化、网络化，推动草牧业业务流程、生产方式重组变革，进而形成数字草牧业协作、资源配置和价值创造运营服务体系。',
            ],
          }
          break
          case 'hy':
          this.initData = {
            title: '数字汇源',
            description:
              '汇源集团（中国果汁行业第一品牌）全产业链数字化服务平台，打造"数字汇源"',
            area: '北京汇源餐饮食品集团有限公司',
            content: [
              ' 汇源集团成立于1992年。目前，汇源已在全国建立140多个经营实体，链接了1000多万亩优质果蔬茶粮等种植基地，20余个农业产业园区，构建一个横跨东西、纵贯南北的大农业格局，形成了一二三产业相互支撑的新型农业体系。以果汁产业为主体，形成了汇源果汁、汇源果业、汇源农业互相促进、共同发展的新格局。 ',
            ],
          }
          break
         case 'ylw':
          this.initData = {
            title: '羊联网',
            description:
              '天津奥群牧业（国家级肉羊核心育种场）肉羊全产业链数字化服务平台，打造“奥群”品牌羊肉',
            area: '天津奥群牧业有限公司',
            content: [
              '天津奥群是一家专注于现代肉羊育种、繁育体系建设及技术创新的国家高新技术企业，多年来从事肉羊品种改良，是全国首批国家级核心育种场，在肉羊育种及产业化推广方面是行业内公认的领军企业之一，也是天津打造百万只肉羊产业计划的“主力军”。',
            ],
          }
          break

        case 'zlw':
          this.initData = {
            title: '猪联网',
            description:
              '农信互联（农业互联网独角兽，B轮融资估值70亿）养猪大数据平台',
            area: '北京农信互联科技集团有限公司',
            content: [
              '北京农信互联科技集团有限公司（nxin.com简称“农信互联”）是一家农业互联网高科技企业。农信互联以“用互联网改变农业”为使命，专注于农业互联网金融生态圈建设，致力于成为最具影响力的农业数据化平台运营商，推动中国农业智慧化转型升级。注册资金3.3亿元，总资产规模超过15亿元。2018年9月，农信互联以增资前70亿元的整体估值正式完成B轮融资，成为农业互联网领域的独角兽企业。',
              '目前，公司已初步建成“数据+电商+金融”三大核心业务平台，并以“农信网”为pc端总入口，“智农通”APP为移动端总入口，构成了从PC到移动端的快乐生态圈，实现对农业全链条的平台服务。',
              '公司的数据业务以“农信云”为基础云服务平台，以“企联网”为SaaS服务平台，利用互联网、物联网、云计算、大数据技术及现代先进的管理理念，联合农村种养户及相关中小微企业，打造农业大数据共享平台，以提高中国农业的整体经营效率。具体规划包括：服务于生猪产业的“猪联网”、服务于饲料企业的“饲联网”，服务于食品屠宰企业的“食联网”，服务于种植产业的“田联网”，服务于水产养殖业的“渔联网”，服务于蛋鸡养殖业的“蛋联网”，服务于柑橘种植业的“柑橘联网”，服务中小商贸企业的“企店”系统等。',
              '公司的电商业务以“农信商城”为核心平台，通过建立涉农电子商务市场，解决交易链条过长、产品品质无法保证、交易成本居高不下、交易体验差等问题。具体规划包括：服务于生猪交易的唯一国家级网上交易平台“国家生猪市场”；服务于养殖户的“畜牧市场”，服务于种植户的“农资市场”，服务于农产品企业的“农产品商城”；服务于柑橘、水产、蛋鸡产业的“柑橘市场”、“渔市场”、“蛋市场”等。',
              '公司的物流业务服务于农业运输的“农信货联”。为解决三农物流难题，推动农产品的快速、高效流通，助推三农发展，利用自身的平台优势，整合各方物流资源，组建一个覆盖全国主要农产品范围的运输业承运人联盟，打造一个有效的农业物流网络，打造农业生态圈链条上的“互联网+交通”项目，用互联网改变农业物流。',
              '公司的金融业务以“农信金服”为主要载体，利用农信平台积累的用户生产经营与交易大数据，依托自主开发的农信资信模型，形成一个面向农户的行业内普惠制、可持续的农业金融服务新体系。具体规划包括：面向农户、涉农企业的征信业务“农信度”、理财业务“农富宝”、供应链金融贷款业务“农信贷”、农业互联网保险经纪业务“农信险”、融资租赁服务“农信租”、保理业务“农信保”、农业产业聚合支付通道“农讯付”，以及对外输出数据分析、风控的科技金融服务等。',
              '公司的人工智能业务，致力于推动互联网、物联网、大数据、人工智能等技术在农业全产业链的落地应用，以推进农业生产智能化、管理数据化和服务在线化为突破口，加速发展智慧农业。2019年初，公司的人工智能业务已取得实质性进展，形成了猪场智能化的超级连接器-猪小智产品，可为猪场提供智能饲喂、智能穿戴、便捷设备、智能终端等多种解决方案。',
            ],
          }
          break

        case 'llw':
          this.initData = {
            title: '驴联网',
            description:
              '东阿阿胶借助数字化平台，从“一张皮到一块胶” 升级到“一头驴到一块胶” 对供应链进行全链条数字化改造，提升品牌价值。',
            area: '东阿阿胶股份有限公司',
            content: [
              '山东东阿阿胶股份有限公司是中国最大的阿胶生产企业，前身为山东东阿阿胶厂，创建于1952年，是全国第一家阿胶国营生产企业。1993年5月改组为股份制企业,1996年“东阿阿胶”A股股票在深圳上市，公司成为上市公司。公司主要生产中成药、生物制剂、保健食品、医疗仪器、药用辅料等6个门类的产品40余种。',
              '公司的主要产品“东阿”牌阿胶，主要是以驴皮为原料进行深加工而成的传统补血类中药，拥有自己的知识产权和核心竞争力，是阿胶年产量、出口量分别占全国75％和90％以上的现代化企业。',
              '“东阿”牌阿胶在阿胶制品中唯一3次荣获国家金质奖；“东阿”牌阿胶在阿胶制品中唯一荣获传统药“长城”国际金奖；“东阿”牌阿胶唯一被评为“全国用户满意产品”；“东阿”牌阿胶通过国家原产地标记注册；“东阿”牌商标被认定为中国驰名商标。 东阿阿胶乘天时与人和之厚德，得地利之优势，承文明之根脉，成功地将具有两千多年历史的阿胶品牌做大、做强，使之迈向现代化、国际化',
            ],
          }
          break

        case 'hlw':
          this.initData = {
            title: '狐联网',
            description:
              '博阳饲料以狐狸产业数字化为入口的皮草产业链整合解决方案',
            area: '博阳双良集团',
            content: [
              '博阳双良集团拥有国内的膨化玉米生产线和专业的毛皮动物饲料生产线。集团现已拥有硕士以上学历技术人员15人；博士以上学历技术人员5人；教授四名并聘请了在芬兰拥有多年毛皮动物养殖经验的汉斯先生为养殖顾问；销售人员均具备畜牧兽医相关专业高学历教育背景；公司管理层先后都接受了清华、北大、人大等高等学府的再度深造学习，公司一直与芬兰、丹麦等毛皮动物饲养技术发达的国家保持合作与交流，同时与国内各高等院校的合作，让我们掌握行业最新的资讯，学习了解行业最新的科研成果。',
              '博阳双良集团的人才价值观：舒心和谐，愉快工作的乐园；是学习成长，共同进步的学校；是展示自我，实现梦想的舞台；并肩携手，共创辉煌的团队。',
              '以品质彰显品牌，以服务塑造形象，以创新成就发展，以和谐谱写*是双良永远坚持的信念。双良集团有着明晰、宏伟的远景规划，以创造客户利益化为己任，以促进行业繁荣发展为目标，提供有竞争力的产品和服务，永做毛皮动物饲料行业人！',
            ],
          }
          break

        case 'kfw':
          this.initData = {
            title: '玉米联网',
            description: '北大荒垦丰种业玉米全流程大数据平台',
            area: '北大荒垦丰种业',
            content: [
              '北大荒垦丰种业是一家集研发、生产、加工、销售、服务和进出口业务于一体，具有完整产业链、多作物经营的现代化大型国有控股种业公司。公司注册资本47,320.70万元，是中国种子行业首批AAA级信用企业、农业部首批32家“育繁推一体化”企业，2013年进入全国信用骨干企业排名前三强，成为信用明星企业，墾豐”商标被认定为中国驰名商标。',
              '公司主要从事玉米、水稻、大豆、麦类等农作物种子研发、生产、加工、推广、经营和服务业务，年销售各类农作物种子25万吨、营业收入近20亿元、净利润超亿元。',
              '公司正在打造“以商业化育种为核心的研发创新体系”、“以全程质量控制为核心的生产加工体系”、“以全方位终端服务为核心的市场营销体系”和“支持与服务型总部”的 “3+1”体系。一是研发创新体系。公司年研发投入占销售总额的5-6%，连续6年年均投入研发经费超亿元,构建了自主研发、合作研发、委托研发、成果收购等多形式、开放式、互利共赢的研发成果转化对接平台，大大提升了公司的研发创新能力，已形成了年参试品种300多个，年审定品种20余个的育种研发能力。二是生产加工体系。公司严格按照ISO9001：2008质量管理体系认证等相关要求，比照国际标准，制定和完善公司质量控制标准及规程，通过现代信息手段确保产品全程可追溯，实现质量控制精细化及质量管理制度化、标准化、程序化。三是营销服务体系。公司建立了电子商务平台—“垦丰商城”，同时结合以直营店、分公司、业务代表、经销商等通路以及商务、结算、配送3个支持系统，打造出线上线下协同的立体营销平台，实现了黑龙江省内种子市场的直营直供，线上线下，网上平台与子分公司、直营店及渠道经销商网络相互配合，打造全方位立体营销平台，完成了财务平台和物流平台的配套建设以及“门对门”配送服务，实现了黑龙江垦区和地方市场线上线下的无缝链接。四是支持和服务型总部。信息化、智能化已全面融入到公司各项工作中，服务与支持型总部正常运转。',
              '公司以成为国内领先、世界一流的大型种业集团为目标，始终践行于“科技与服务，创造美好生活”的企业使命，坚持“品行天下，质创未来”的经营理念，通过提供优良品种及种植解决方案，为农民创造价值，推动现代农业发展！',
            ],
          }
          break

        case 'dlw':
          this.initData = {
            title: '蛋联网',
            description:
              '德青源打造供应链数字化平台，转型成为标准商、服务商、品牌商，最大化企业价值',
            area: '德清源',
            content: [
              '德青源在中国布局 35 个国际标准的生态农场，开创可持续发展的生态农业模式，实现生态养殖、食品加工、清洁能源、环保设备、有机肥料、订单农业、有机种植的生态循环。',
              '德青源是农业产业化国家重点龙头企业，是中共中央政治局第 39 次集体学习的全国农业产业扶贫典范，是中国环境保护、食品安全、精准扶贫的核心力量。德青源依据欧盟标准，引领中国蛋品新规范:蛋壳上有品牌、有生产日期、有农场追溯码，结束中国几千年的鸡蛋“三无”历史，确保消费者的食品安全。',
              '德青源始终坚持欧盟标准防疫，无抗生素困扰;始终坚持智能蛋壳清洁，无致病菌困扰;始终坚持绿色纯粮喂养，无药残蛋困扰，是真正意义的安全鸡蛋。 德青源鸡蛋供应香港 12 年，堪称安全典范。',
              '德青源是“中国航天事业合作伙伴”，用航天标准严格要求德青源鸡蛋的安全品质。',
            ],
          }
          break

        case 'dsw':
          this.initData = {
            title: '河南大蒜现货交易中心',
            description: '河南开封杞县大蒜现货交易市场数字化解决方案',
            area: '河南杞县',
            content: [
              '杞县独特的地理、气候、土壤等优势，让杞县的大蒜种植业迅猛发展。截至2018年，杞县大蒜种植已超过70万亩，产量90万吨，产量及规模均居全国县域第一位，是全国最大的大蒜种植和出口基地。',
              '杞县拥有大蒜交易市场30多个，其中专业化的大蒜交易市场杞县金杞国际大蒜交易市场，占地近600亩，交易辐射周边10多个市、县，2017年市场内大蒜交易量达60余万吨，交易额55亿元。',
            ],
          }
          break

        case 'jlw':
          this.initData = {
            title: '银耳联网',
            description:
              '福建省古田县现代农业产业园（全国银耳主产区）数字化服务平台',
            area: '福建古田',
            content: [
              '位于闽东山区的古田县，以“中国食用菌之都”著称，其“古田银耳”是国家地理标志性产品，全县银耳产量占全国的90%以上，鲜品年产量达33万吨，产值近20亿元，种植规模、产量、产值、出口量均居全国首位。目前，食用菌产业已经成为古田县的支柱产业、特色产业和富民产业。其中，银耳产业是古田县的特色精准扶贫产业，古田农民约70%的收入来自银耳等食用菌产业。',
            ],
          }
          break

        case 'hsw':
          this.initData = {
            title: '马铃薯联网',
            description:
              '内蒙古乌兰察布（中国薯都）以马铃薯为抓手，通过数字化手段，实现产业聚集发展，带动区域经济',
            area: '华颂种业',
            content: [
              '华颂种业公司注册资本10267.0468万元，总部设在北京市中关村科技园区，拥有5家控股子公司，是中国蔬菜流通协会马铃薯委员会主任委员单位。公司下设育种研究院、种薯公司、商品薯公司、种植服务公司、土豆食品公司、产业大数据平台公司6大板块，致力于成为全球领先的马铃薯全产业链品牌服务企业。 公司拥有1个脱毒种苗供应中心、3个组培扩繁中心，4个原原种生产基地，6个大田种薯生产基地。现投产组培脱毒中心7400平米，温网室500多亩，大田生产基地1.3万亩，年产脱毒原原种8000万粒，脱毒种薯4万吨。',
              '公司以马铃薯品种研发为核心，育成华颂系列新品种10多个。其中华颂7号被大众评为舌尖上的土豆，一薯难求。商品薯种植合作伙伴遍及全国26个省市，会员单位3000多个，拥有优质土豆种植基地200万亩，可周年供应优质土豆上市。',
              '2018年公司被评为“国家级高新技术企业”、“中关村高新技术企业”、“内蒙古自治区扶贫龙头企业”、“内蒙古自治区农牧业产业化重点龙头企业”、“赤峰市农牧业产业化重点龙头企业”、“赤峰市农牧业产业化示范联合体”、“赤峰市扶贫龙头企业”、“绿色食品认证”、“赤峰名优特农畜产品”、“2018年度脱贫攻坚‘百企帮百村’活动先进企业”、“2017全国十佳蔬菜产业服务企业”、“2017最具成长性蔬菜品牌企业”、“2017全国十佳蔬菜品牌IP”、“2017全国蔬菜产业扶贫突出贡献奖”、“2016中国品牌食材企业”、“2016马铃薯产业十佳服务商”。在全国范围贫困县通过推行马铃薯全产业链服务MPP( Modern Potato Platform )模式，发挥产业优势，助力脱贫攻坚，带动农民致富。通过打造产业平台迅速聚集产业资源，全产业链品牌运作销售商品薯，带动种薯销售，形成产业生态闭环商业模式。',
              '生产实现了专业化、程序化、标准化、机械化、数字化的生产模式，为客户提供优质高端脱毒种薯和优质商品薯，努力引领马铃薯产业科技创新发展。',
              '公司拥有先进的马铃薯育种、种薯脱毒及生产技术，拥有以硕士博士为主的企业管理、技术研发、种薯生产、农产品经营、市场开拓等高层次人才团队70多人，与中国农业科学院、美国密歇根州立大学、荷兰瓦赫宁根大学、内蒙古农业大学、云南省农科院等国内外顶尖马铃薯科研单位建立了良好的合作关系。',
            ],
          }
          break

        case 'gjw':
          this.initData = {
            title: '柑橘联网',
            description: '重庆忠县（全国柑橘主产地）“忠橙”品牌数字化解决方案',
            area: '重庆忠县',
            content: [
              '忠县柑橘，重庆市忠县特产，中国国家地理标志产品。',
              '忠县地处重庆中部、三峡库区腹心，种植柑橘历史悠久、技术先进，是全市柑橘产业的核心区和示范区，具有明显的比较优势。忠县地处暖湿亚热带东南季风区，属亚热带东南季风区山地气候。温热寒凉，四季分明，雨量充沛，日照充足，特别适宜柑橘的栽培，所产柑橘颜色鲜艳，果形美观，汁多化渣。',
              '2010年11月23日，原国家质检总局批准对“忠县柑橘”实施地理标志产品保护。2019年11月，忠县柑橘上榜中国农业品牌目录。',
            ],
          }
          break

        case 'zjs':
          this.initData = {
            title: '国家生猪市场',
            description: '重庆荣昌国家级生猪市场数字化平台升级解决方案',
            area: '国家生猪市场',
            content: [
              '国家生猪市场是农业部按照国家“十二五”规划纲要建设的唯一一个和生猪相关的国家级大市场，目前由北京农信互联科技有限公司旗下重庆农信生猪交易公司作为运营主体。',
              '结合生猪流通行业的特点，借助移动互联网及电子商务的先进技术，有效解决猪交易过程中交易链条过长、品质无法保证、质量不可追溯、交易成本居高不下、交易体验差等问题，有效破解我国生猪价格长期剧烈波动，提升我国生猪产业核心竞争力。',
            ],
          }
          break
        case 'xxtd':
          this.initData = {
            title: '嗅嗅达人探店',
            description: '达人探店综合解决方案',
            area: '嗅嗅达人探店',
            content: [
              '北京畎畎科技有限公司是一家专注于本地生活资源整合和经营效率优化的全国性消费科技综合服务平台，由广东驴友、北京农信互联、北京晴云资本共同创办。平台主要为达人、商家提供资源共享、降本增效的服务；为消费者提供更贴心、更直观的需求选择。致力于自媒体及视频电商领域的应用研发、运营策划、项目管理等方面，平台具备超前的技术水平和丰富的实践经验，组建了技术研发、新媒体运营、业务拓展、客户服务四大核心团队。',
              '畎畎科技不仅是看重本地生活领域的前景，更是看重达人经济整合本地生活资源之后的能效提升，独辟蹊径地打造超级推广平台，帮助更多的商家提升经营效果，也帮助更多的达人实现流量变现。',
            ],
          }
          break
          case 'yxzh':
          this.initData = {
            title: '益信种植',
            description: '益信种植综合解决方案',
            area: '益信种植',
            content: [
              '肇庆市益信农业发展有限公司成立于1994年11月，是一家以生猪养殖为主的农牧企业，目前总存栏能繁母猪3万多头，年出栏生猪近70万头，其中封开县能繁母猪存栏1.2万头，年出栏生猪达30万头。近年来，公司属下肇庆市益信原种猪场有限公司先后获评“全国畜禽养殖标准化示范场”“国家生猪核心育种场”“国家级生猪产能调控基地”“国家高新技术企业”“广东省重点农业龙头企业”等荣誉称号。益信公司在立足生猪产业的基础上，2022年3月10日成立了广东省益信农业科技有限公司，定位为一家集粮食作物种植、畜牧养殖、粮食加工、仓储冷链于一体的现代农业企业，并以之作为经营承载主体，着力推进本地撂荒地复耕复种工作，拟通过建立示范点，以点带面、联农带农的方式，大面积种植水稻、玉米、油菜等粮食作物，充分利用自身生猪产业优势，强力推进畜牧粪肥资源化循环利用。同时配套建设一个集农产品加工、仓储及物流于一体的农业服务中心，为企业和当地广大农户提供有效社会服务，同广大同仁一道，助推乡村振兴战略全面实施。',
            ],
          }
          break
          case 'gjjys':
          this.initData = {
            title: '重庆三峡柑橘交易中心',
            description: '重庆三峡柑橘交易中心数字化平台，聚集柑橘产业全方位资源',
            area: '重庆三峡柑橘交易中心',
            content: [
              '重庆三峡柑橘交易中心是省部共建国家级忠县柑橘产地市场的核心组成部分，是立足重庆、辐射全国的柑橘全产业链大宗现货交易平台，是通过柑橘全产业链整体构建集“交易、信息、物流、金融、加工、溯源”等服务功能为一体的综合性平台。',
            ],
          }
          break
          case 'xhj':
          this.initData = {
            title: '杏花鸡',
            description: '杏花鸡综合解决方案',
            area: '杏花鸡',
            content: [
              '肇庆市封开县的杏花鸡养殖已有1000多年历史，早在唐朝，状元莫宣卿把家乡封开的杏花鸡带到京都呈上，让封开杏花鸡在千年前就名声大噪，成为朝廷贡品，也成就了流传在广东大地“无鸡不成宴”的佳话。20世纪90年代，当地政府积极开展保种育种工作，购回纯种鸡，成立杏花鸡繁育中心，采用“公司+农户”的方式实现规模化养殖，杏花鸡也从以往平均重1.8斤提升到2.5斤左右。随着杏花鸡品质的提升，其品牌也逐渐打响。封开杏花鸡不仅是广东三大名鸡之一，还被评为“广东最具人气土特产”“广东十大名牌农产品”，2018年3月正式被列为国家地理标志保护产品。',
            ],
          }
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/assets/pc/css/demo.scss';
</style>
